import { render } from "./MasterFacts.vue?vue&type=template&id=ced000a2"
import script from "./MasterFacts.vue?vue&type=script&lang=js"
export * from "./MasterFacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__